<ng-container
  *ngIf="!isreadyToDisplay() && isSdfCardFlow; else referenceNumber"
>
  <div class="spinner-overlay">
    <div class="spinner-container">
      <div class="spinner-background"></div>
      <img src="assets/images/spinner.gif" alt="spinner" />
    </div>
  </div>
</ng-container>

<ng-template #referenceNumber>
  <app-partner-wallet-banner
    class="partner-wallet"
    [walletProvider]="getFormattedWalletName()"
    [stepper]="null"
    [showBackIcon]="false"
  ></app-partner-wallet-banner>
  <div class="mg-access-top-nav">
    <div class="content-body">
      <div class="mg-logo-container">
        <img
          class="mg-logo"
          src="assets/images/mgo-logo-black.svg"
          alt="MoneyGram"
        />
      </div>
      <div class="empty-container-placeholder"></div>
      <div class="language-cont-selector">
        <app-language-selector
          [labels]="(labels$ | async)?.labels"
          [languages]="languageList"
        ></app-language-selector>
      </div>
      <div class="supportBtn-container">
        <app-card-customer-support
          [labels]="labels"
        ></app-card-customer-support>
      </div>
    </div>
  </div>
  <div class="transaction-status-wrapper">
    <div class="title-and-icon-container">
      <div class="icon">
        <img src="{{ transactionStatusIconSrc }}" alt="confirmation-icon" />
      </div>
      <div class="header">
        <div class="text-content">
          {{ trnStatus }}
        </div>
      </div>
    </div>

    <ng-container
      *ngIf="kind === 'deposit' && transactionStatus === 'pending_anchor' && !!helpText"
    >
      <div class="help-text-container">
        <p>{{ helpText }}</p>
        <ng-container
          *ngIf="!!helpTextLine2"
        >
          <p>{{ helpTextLine2 }}</p>
        </ng-container>
      </div>
    </ng-container>

    <ng-container
      *ngIf="(kind === 'deposit' && !isformFreeLocation) || kind === 'withdraw'"
    >
      <div class="filled-blue-container">
        <div class="ref-or-account-num">
          {{ getConfirmationCode() }}
        </div>
        <div class="share-icon-container">
          <img
            src="assets/images/share-icon.svg"
            alt="share-icon"
            (click)="copyCode()"
          />
        </div>
      </div>
    </ng-container>

    <div class="amount-container">
      <div class="pickAmount">
        <div class="pickAmount-text">
          {{ amountPaidOrPayAtStore }}
        </div>
      </div>
      <div class="amount">
        <div class="amount-text">
          {{ totalAmount }}
        </div>
        <div class="currency-amount">
          {{ totalAmountCurrency }}
        </div>
      </div>
      <div class="text-exp-header">
        <div class="text-exp">
          {{ withdrawnOrDepositAmountString }}
        </div>
      </div>
      <div class="rec-name" *ngIf="showPayInstructions">
        <div class="rec-name-label">
          {{ sdfCardLabels.confirmationPage.receiver }}:
        </div>
        <div class="recName">
          {{ getUserName() }}
        </div>
      </div>
    </div>

    <ng-container *ngIf="showPayInstructions">
      <div class="next-steps-wrapper">
        <div class="next-steps">
          <div class="header">
            <p class="header-text">
              {{ sdfCardLabels.confirmationPage.nextStepsHeading }}
            </p>
          </div>
          <!-- Implicit US Canada and deposit kind  -->
          <ng-container
            *ngIf="
              !isformFreeLocation &&
              kind === 'deposit' &&
              isImplicitUSCanLocation
            "
          >
            <div class="next-steps-items">
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 1 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishWithIn"
                  class="item-details"
                >
                  Within <span class="hours-bold">24 hours</span>, head to
                  <span class="paymentLocation-bold-underline"
                    >your payment location</span
                  >
                </div>
                <ng-template #nonEnglishWithIn>
                  <div class="item-details">
                    {{ sdfCardLabels.confirmationPage.nextSteps.paraOne }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 2 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishIdOne"
                  class="item-details"
                >
                  Have your
                  <span class="photo-id">{{
                    getSelectedIdInfo(primaryIdDetails)
                  }}</span>
                  selected and
                  <span class="accouunt-bold">Account #</span> above ready
                </div>
                <ng-template #nonEnglishIdOne>
                  <div class="item-details">
                    {{ getPrimaryIdString() }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 3 </span>
                </div>
                <div class="item-details-wrapper">
                  <div class="item-details">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps
                        .tellTheStoreEmployee
                    }}
                  </div>
                  <div
                    *ngIf="isEnglishFlow; else nonEnglishSendMoney"
                    class="item-details bold"
                  >
                    I am here to send money to <span class="state">Texas</span>,
                    <span class="country">United States.</span>
                  </div>
                  <ng-template #nonEnglishSendMoney>
                    <div class="item-details bold">
                      {{
                        sdfCardLabels.confirmationPage.nextSteps.fundsIn
                          .paraThree.implicitTransUSCAN.purpose
                      }}.
                    </div>
                  </ng-template>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .serviceOption
                    }}
                  </div>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .yourNameAsReceiver
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- formFreeLocation none US and Canada countries and deposit kind -->
          <ng-container
            *ngIf="
              !isformFreeLocation &&
              kind === 'deposit' &&
              !isImplicitUSCanLocation
            "
          >
            <div class="next-steps-items">
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 1 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishWithIn"
                  class="item-details"
                >
                  Within <span class="hours-bold">24 hours</span>, head to
                  <span class="paymentLocation-bold-underline"
                    >your payment location</span
                  >
                </div>
                <ng-template #nonEnglishWithIn>
                  <div class="item-details">
                    {{ sdfCardLabels.confirmationPage.nextSteps.paraOne }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 2 </span>
                </div>
                <div
                  *ngIf="isEnglishFlow; else nonEnglishIdOne"
                  class="item-details"
                >
                  Have your
                  <span class="photo-id">{{
                    getSelectedIdInfo(primaryIdDetails)
                  }}</span>
                  selected and
                  <span class="accouunt-bold">Account #</span> above ready
                </div>
                <ng-template #nonEnglishIdOne>
                  <div class="item-details">
                    {{ getPrimaryIdString() }}
                  </div>
                </ng-template>
              </div>
              <div class="item-group">
                <div class="item-number">
                  <span class="number"> 3 </span>
                </div>
                <div class="item-details-wrapper">
                  <div class="item-details">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps
                        .tellTheStoreEmployee
                    }}
                  </div>
                  <div
                    *ngIf="isEnglishFlow; else nonEnglishSendMoney"
                    class="item-details bold"
                  >
                    I am here to send money to
                    <span class="country">the United States.</span>
                  </div>
                  <ng-template #nonEnglishSendMoney>
                    <div class="item-details bold">
                      {{
                        sdfCardLabels.confirmationPage.nextSteps.fundsIn
                          .paraThree.implicitNoneUSCAN.purpose
                      }}.
                    </div>
                  </ng-template>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .serviceOption
                    }}
                  </div>
                  <div class="item-details bold">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps.fundsIn.common
                        .yourNameAsReceiver
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Explicit cashin and deposit kind next steps -->
          <div
            class="next-steps-items"
            *ngIf="isformFreeLocation && kind === 'deposit' && !isCVSLocation"
          >
          <div class="item-group">
            <div class="item-number">
              <span class="number"> 1 </span>
            </div>
            <div
              *ngIf="isEnglishFlow; else nonEnglishWithIn"
              class="item-details"
            >
              Visit within <span class="hours-bold">24 hours</span>
              
            </div>
            <ng-template #nonEnglishWithIn>
              <div class="item-details">
                {{
                  sdfCardLabels?.confirmationPage?.nextSteps?.fundsInUpdated?.first || 'Visit within 24 hours'
                }}
              </div>
            </ng-template>
          </div>
          <div class="item-group">
            <div class="location-info" *ngIf="locationDetails">
              <div class="item-details">
                <div class="location-name">{{ locationDetails.name }}</div>
                <div class="location-address">{{ getAddressInfo(true) }}</div>
              </div>
            </div>
          </div>
          <div class="item-group">
            <div class="item-number">
              <span class="number"> 2 </span>
            </div>
            <ng-template #nonEnglishIdOne>
              <div class="item-details">
                {{ getPrimaryIdString() }}
              </div>
            </ng-template>
            <div class="item-group">
              <div class="item-details-wrapper">
                <div class="item-details">
                  {{
                    sdfCardLabels.confirmationPage.nextSteps
                      .tellTheStoreEmployee
                  }}
                </div>
                <ul>
                  <li style="margin-bottom: 10px;">
                    <div
                    class="item-details"
                  >
                  {{
                    sdfCardLabels?.confirmationPage?.nextSteps?.fundsInUpdated?.nonCvs?.secondSubOne || 'I want to make a Wallet Deposit with MoneyGram'
                  }}
                  </div>
                  </li>
                  <li style="margin-bottom: 10px;">
                      <div class="item-details">
                        {{
                          sdfCardLabels?.confirmationPage?.nextSteps?.fundsInUpdated?.nonCvs?.secondSubTwo || 'Ask them to select the new Wallet Deposit button'
                        }}
                      </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
          <!-- Explicit cashin and deposit kind next steps - CVS Location -->
          <div
            class="next-steps-items"
            *ngIf="isformFreeLocation && kind === 'deposit' && isCVSLocation"
          >
            <div class="item-group">
              <div class="item-number">
                <span class="number"> 1 </span>
              </div>
              <div
                *ngIf="isEnglishFlow; else nonEnglishWithIn"
                class="item-details"
              >
                Visit within <span class="hours-bold">24 hours</span>
                
              </div>
              <ng-template #nonEnglishWithIn>
                <div class="item-details">
                  {{
                    sdfCardLabels?.confirmationPage?.nextSteps?.fundsInUpdated?.first || 'Visit within 24 hours'
                  }}
                </div>
              </ng-template>
            </div>
            <div class="item-group">
              <div class="location-info" *ngIf="locationDetails">
                <div class="item-details">
                  <div class="location-name">{{ locationDetails.name }}</div>
                  <div class="location-address">{{ getAddressInfo(true) }}</div>
                </div>
              </div>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number"> 2 </span>
              </div>
              <ng-template #nonEnglishIdOne>
                <div class="item-details">
                  {{ getPrimaryIdString() }}
                </div>
              </ng-template>
              <div class="item-group">
                <div class="item-details-wrapper">
                  <div class="item-details">
                    {{
                      sdfCardLabels.confirmationPage.nextSteps
                        .tellTheStoreEmployee
                    }}
                  </div>
                  <ul>
                    <li style="margin-bottom: 10px;">
                      <div
                        class="item-details"
                      >
                      {{
                        sdfCardLabels?.confirmationPage?.nextSteps?.fundsInUpdated?.cvs?.secondSubOne || 'I want to send money'
                      }}
                    </div>
                    </li>
                    <li style="margin-bottom: 10px;">
                        <div class="item-details">
                          {{
                            sdfCardLabels?.confirmationPage?.nextSteps?.fundsInUpdated?.cvs?.secondSubTwo || 'The transaction is already in the system and no kiosk needed'
                          }}
                        </div>
                    </li>
                  </ul>  
                </div>
              </div>
            </div>
          </div>
          <!-- Withdraw kind next steps -->
          <div class="next-steps-items" *ngIf="kind === 'withdraw'">
            <div class="item-group" *ngIf="shouldShowFirstBulletPoint()">
              <div class="item-number">
                <span class="number">1</span>
              </div>
              <div class="item-details" [innerHTML]="getFirstBulletPoint()"></div>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number">{{ shouldShowFirstBulletPoint() ? '2' : '1' }}</span>
              </div>
              <div class="item-details location">
                <div
                  *ngIf="isEnglishFlow; else nonEnglishWithin"
                  class="first-content"
                >
                  Within <span class="days-bold">60 days</span>, head to
                  <span class="pickup-Location-bold"
                    >any store from your search result</span
                  >
                </div>
                <ng-template #nonEnglishWithin class="first-content">
                  <div class="item-details">
                    {{ sdfCardLabels.confirmationPage.nextSteps.fundsOut.paraOne }}
                  </div>
                </ng-template>
                <div class="lookup-location">
                  <app-moneygram-locations-link
                    [google]="google"
                    [kind]="kind"
                    [isSdfCardFlow]="true"
                    [labels]="labels"
                    [kind]="kind"
                  ></app-moneygram-locations-link>
                </div>
              </div>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number">{{ shouldShowFirstBulletPoint() ? '3' : '2' }}</span>
              </div>
              <div
                *ngIf="isEnglishFlow; else nonEnglishId"
                class="item-details"
              >
                Have your
                <span class="photo-id">{{
                  getSelectedIdInfo(primaryIdDetails)
                }}</span>
                selected and
                <span class="accouunt-bold">Reference #</span> above ready
              </div>
              <ng-template #nonEnglishId class="item-details">
                <div class="item-details">
                  {{ getPrimaryIdString() }}
                </div>
              </ng-template>
            </div>
            <div class="item-group">
              <div class="item-number">
                <span class="number">{{ shouldShowFirstBulletPoint() ? '4' : '3' }}</span>
              </div>
              <div class="item-details-wrapper">
                <div class="item-details">
                  {{
                    sdfCardLabels.confirmationPage.nextSteps
                      .tellTheStoreEmployee
                  }}
                </div>
                <div class="item-details bold">
                  {{
                    sdfCardLabels.confirmationPage.nextSteps.fundsOut
                      .receiveCash
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="help-text">
            <p class="help-text-label">
              {{ sdfCardLabels.confirmationPage.walletBalance }}.
            </p>
          </div>
        </div>
      </div>
    </ng-container>

    <app-card-summary-section
      class="card-sum-section"
      *ngFor="let section of sections"
      [items]="section.items"
      [title]="section.title"
      [footer]="section.footer"
    >
    </app-card-summary-section>

    <div class="call-to-action-btn-container gap">
      <section class="form-button-container">
        <div class="button-container">
          <button class="formBtn" (click)="closeWindow()">
            <span class="label">{{ sdfCardLabels.common.done }}</span>
          </button>
        </div>
      </section>
      <section *ngIf="isRefundAllowed" class="cancel-button-container">
        <div class="button-container">
          <button class="formBtn border-less-button" (click)="cancelTransfer()">
            <div class="label">
              {{ sdfCardLabels.common.cancelTransaction }}
            </div>
          </button>
        </div>
      </section>
    </div>
    <app-powered-by-stellar
      class="powered-by-stellar-contiainer"
    ></app-powered-by-stellar>
  </div>
</ng-template>
